import Component from '@glimmer/component';

import CButton from 'rise-ui/components/c-button.gjs';
import CIcon from 'rise-ui/components/c-icon.gjs';

export default class NextStepComponent extends Component {
  <template>
    <CButton
      @type="primary"
      @disabled={{@disabled}}
      @title={{@title}}
      @linkTo={{@linkTo}}
      @action={{@action}}
    >
      {{#if (has-block)}}{{yield}}{{else}}Next Step{{/if}}
      <CIcon @icon="next-step" @text="Next Step" />
    </CButton>
  </template>
}
